<!--tab栏-->
<template>
  <div class="tabTemplate">
    <!-- 顶部标题 -->
    <div class="tabTitle display-flex align-items-center fs-12">
      <img class="logo" src="../../assets/public/logo.png" />
      <el-breadcrumb separator=">" class="flex-grow-1 fs-12">
        <el-breadcrumb-item :replace="true" :to="item.router ? {name: item.router, query:item.query }: '' "
          :key="item.name" v-for="(item,index) in pageList">
          <span v-if="item.name">{{item.name}}</span>
          <span v-else-if="item.language">{{$t(item.language)}}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 语言切换 -->
      <!-- <div class="languageCut click ml-19 btnBg">
        <img src="../../assets/tab/icon_language.svg" />
        <div class="languagePopup c-4e5661 fs-14">
          <div :class="{'isSelect':selectLanguage.key==item.key}" @click="onClickCutLanguage(item)"
            v-for="item in languageList" class="line-1">{{item.name}}</div>
          <div class="blank"></div>
        </div>
      </div> -->
      <!-- 全屏显示 -->
      <div @click="onClickFullScreen()" :isFullScreen="isFullScreen" class="btnBg fullScreen click ml-9">
        <div class="icon"></div>
        <div class="promptBox fs-12 c-f">{{isFullScreen?$t('tab.exitFullScreen'):$t('tab.fullScreen')}}
          <div class="triangle"></div>
        </div>
      </div>
      <div class="headPortrait ml-25">
        <div class="defaultHead head">
          <div :style="userInfo.avatar | setBackground()" class="headPicture"></div>
        </div>
        <div class="headPopup fs-14">
          <div class="display-flex align-items-center click name c-152338">
            <div class="width-100">
              <div class="fs-16 display-flex align-items-center">
                <div class="flex-grow-1 line-1 text">{{userInfo.nickName}}</div>
                <!-- <div class="arrow-right"></div> -->
              </div>
            </div>
          </div>
          <!-- 修改密码 -->
          <div @click="onClickChangePassword()" class="display-flex align-items-center option click">
            <img src="../../assets/tab/icon_changePassword.png" />
            <div class="ml-14 line-1">{{$t('tab.changePassword')}}</div>
          </div>
          <!-- 退出登录 -->
          <div @click="onClickLogout()" class="display-flex align-items-center option click">
            <img src="../../assets/tab/icon_log_out.svg" />
            <div class="ml-14 line-1">{{$t('tab.logOut')}}</div>
          </div>
          <div class="blank"></div>
        </div>
      </div>
    </div>
    <div class="display-flex tabContent">
      <div class="tabMenuLayout flex-shrink-0">
        <scrollView :class="{'retract': isHiddenMenuList}" class="flex-shrink-0">
          <el-menu class="el-menu-vertical-demo tabMenu" background-color="#152338" :default-active="$route.meta.group"
            router>
            <div :key="item.code" v-for="item in menuList">
              <!-- 页面类型 -->
              <el-menu-item :index="item.path" v-if="item.type == 'page'"
                class="oneLevel display-flex align-items-center">
                <div class="icon flex-shrink-0">
                  <!-- 图标 -->
                  <img width="20" :src="item.icon | setBackground('img')" />
                </div>
                <div class="line-1 flex-grow-1">{{item.name}}</div>
              </el-menu-item>
              <el-submenu :index="item.code" v-else-if="item.type == 'menu'">
                <template slot="title">
                  <div class="icon">
                    <!-- 图标 -->
                    <img width="20" :src="item.icon | setBackground('img')" />
                  </div>
                  <div class="flex-grow-1 line-1">{{item.name}}</div>
                </template>
                <el-menu-item :index="children.path" :key="children.code" v-for="children in item.children">
                  <!-- <div class="icon-arrow"></div> -->
                  <div class="flex-grow-1 line-1">{{children.name}}</div>
                </el-menu-item>
              </el-submenu>
            </div>
            <div class="blank"></div>
          </el-menu>
        </scrollView>
        <div @click="onClickRetractMenu()" class="retractMenu"></div>
      </div>

      <div v-loading="isLoading" class="contentLayout">
        <div style="min-width: 1024px;height: 100%;">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import i18next from 'i18next';
  import '@/style/tab/tab.scss';

  export default {
    name: 'tab',
    data() {
      return {
        userInfo: "",
        isLoading: false,
        isFullScreen: false, //当前是否全屏
        selectLanguage: null, //当前选中的语言
        isHiddenMenuList: false, // 是否隐藏左侧菜单
        pageList: [], //页面列表
        languageList: [], //国际化列表
        menuList: [],
      }
    },
    created() {
      this.userInfo = this.$utils.userInfo;
      if (this.$route.meta.isHiddenMenuList) {
        this.isHiddenMenuList = true;
      }
      Vue.prototype.$tabSelf = this;
      this.initLanguage();
      document.addEventListener("keydown", (event) => {
        if (event.keyCode == 27 || event.keyCode == 122) {
          if (this.isFullScreen) {
            this.isFullScreen = false;
          }
        }
      })
      // 获取菜单列表
      let menuList = this.$utils.getMenuList();
      this.setMenuList(menuList);
    },
    mounted() {},
    methods: {
      // 隐藏菜单栏
      onClickRetractMenu() {
        this.isHiddenMenuList = !this.isHiddenMenuList;
      },
      initLanguage() {
        this.languageList = this.$utils.getLanguageList();
        // 设置语言
        let language = localStorage.getItem("language");
        if (language) {
          for (let i = 0; i < this.languageList.length; i++) {
            if (this.languageList[i].key == language) {
              this.selectLanguage = this.languageList[i];
              continue;
            }
          }
        } else {
          this.selectLanguage = this.languageList[0];
        }
      },
      /**
       * 设置菜单
       */
      setMenuList(menuList) {
        this.menuList = menuList;
        if (menuList.length == 0) return;
        if (this.$route.path == "/tab") {
          if (this.menuList[0].type == "menu") {
            this.$router.push({
              path: this.menuList[0].children[0].path
            });
          } else if (this.menuList[0].type == "page") {
            this.$router.push({
              path: this.menuList[0].path
            });
          }
        }
      },
      /**
       * 切换语言
       * @param {Object} item 语言类型实体
       */
      onClickCutLanguage(item) {
        this.$i18n.locale = item.key;
        i18next.changeLanguage(item.key);
        this.selectLanguage = item;
        localStorage.setItem("language", item.key);
        let that = this;
        this.$nextTick(function() {
          that.bus.$emit('onChangelanguage');
        })
      },
      /**
       * 全屏/取消全屏
       */
      onClickFullScreen() {
        if (this.isFullScreen || document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen) {
          this.isFullScreen = false;
          this.exitScreen();
        } else {
          this.isFullScreen = true;
          this.fullScreen();
        }
      },
      /**
       * 全屏显示
       */
      fullScreen() {
        let el = document.documentElement;
        let rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el
          .msRequestFullscreen;
        if (typeof rfs != "undefined" && rfs) {
          rfs.call(el);
        };
        return;
      },
      /**
       * 退出全屏
       */
      exitScreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        if (typeof cfs != "undefined" && cfs) {
          cfs.call(el);
        }
      },
      /**
       * 退出登录
       */
      onClickLogout() {
        this.$utils.exitLogin(this.$router);
        // let params = {
        //   url: this.$request.url.login.exitLogin,
        //   headers: {
        //     Authorization: "Bearer " + this.userInfo.access_token,
        //     'X-Requested-Code': this.userInfo.tenant_code
        //   },
        //   data: {}
        // }
        // this.$request.delete(params, function(type, response) {});
      },
      // 点击修改密码
      onClickChangePassword() {
        this.$router.push({
          name: "changePassword"
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/tab/tab.vue